var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-100 d-flex flex-column" }, [
    _c("div", { staticClass: "sidebar-top p-3" }, [_c("prompt")], 1),
    _vm._v(" "),
    _c("div", { staticClass: "sidebar-bot btn-box" }, [
      _c("img", {
        staticClass: "w-100 mask-image",
        attrs: { src: this.resultPage.outputImage },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }